import { render, staticRenderFns } from "./basicInfoHongkong.vue?vue&type=template&id=f5142b58"
import script from "./basicInfoHongkong.vue?vue&type=script&lang=js"
export * from "./basicInfoHongkong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports